export const resonance = {
  resonance_title: 'تطبيق Resonance',
  resonance_open_app_on_mobile: 'افتح التطبيق على الهاتف المحمول',
  resonance_open_app_on_mobile_description: 'لتجربة أفضل، نوصي باستخدام تطبيق الهاتف المحمول.',
  resonance_open_app_on_mobile_button: 'افتح التطبيق على الهاتف المحمول',
};
